import React, {useState} from "react";
import SkynetIcon from "../../Fundamentals/SkynetIcon";
import jsonUtils from "../../../Utils/jsonUtils";

export function AppConfigTable({ appConfigs, onEditClick }) {
    return (<div className="table-responsive">
            <table className="table table-stripe">
                <thead>
                <tr>
                    <th>{"Key"}</th>
                    <th>{"Description"}</th>
                    <th>{"Edit"}</th>
                </tr>
                </thead>
                <tbody>
                {appConfigs?.map((config) => {
                    return <AppConfigRow key={config.name} config={config} onEditClick={onEditClick} />
                })}
                </tbody>
            </table>
        </div>
    );
}

function AppConfigRow({ config, onEditClick }) {
    const [active, setActive] = useState(false);

    const handleRowClick = () => {
        setActive(!active);
    };

    return (<>
        <tr onClick={handleRowClick} className={`cursorpointer${active ? ' active' :''}`}>
            <td className={active ? "bold" : undefined}>
                <div className="d-flex align-items-center">
                    <span className={`caret caret-lg ${active ? ' open': ''}`}></span>
                    <div className="ml-24">{config.name}</div>
                </div>
            </td>
            <td>{config.description}</td>
            <td>
                <SkynetIcon icon={'vismaicon-edit'} onClick={(e) => onEditClick(e,config)} />
            </td>
        </tr>
        {active &&
            <tr key={config.name + "-value"}>
                <td colSpan={3}>
                    <AppConfigValue value={config.value}/>
                </td>
            </tr>
        }
    </>)
}

function AppConfigValue({ value }) {
    try {
        const parsed = JSON.parse(value);
        if (parsed !== null) {
            return <div className="pl-48">{jsonUtils.formatJsonObject(parsed, 0)}</div>;
        }

    } catch (error) {
        console.error("oh no", error)
    }
    return <div className="pl-48">{value}</div>;
}